__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/35c4682/_next/";